export const getImage = src => ({ url: src })
